import React from "react";

/**
 * All motion here is transform/opacity only and eased — no `linear`, no
 * spinning arc, no gradient text. The ground is `bg-bg` so the loader never
 * flashes a dark plate in front of a light page.
 */
const loaderCSS = `
  @keyframes wh-pulse-ring {
    0%, 100% { opacity: 0.25; transform: scale(0.92); }
    50%      { opacity: 0.7;  transform: scale(1.06); }
  }
  @keyframes wh-dot-bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.35; }
    40%           { transform: scale(1);   opacity: 1;    }
  }
  .wh-pulse-ring { animation: wh-pulse-ring 2s ease-in-out infinite; }
  .wh-pulse-ring-2 { animation: wh-pulse-ring 2s ease-in-out infinite 0.35s; }
  .wh-dot1 { animation: wh-dot-bounce 1.4s ease-in-out infinite 0s;   }
  .wh-dot2 { animation: wh-dot-bounce 1.4s ease-in-out infinite 0.2s; }
  .wh-dot3 { animation: wh-dot-bounce 1.4s ease-in-out infinite 0.4s; }
`;

const Loader = () => (
  <>
    <style>{loaderCSS}</style>
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-bg">

      {/* Rings */}
      <div className="relative flex items-center justify-center w-36 h-36">
        <div className="wh-pulse-ring absolute w-32 h-32 rounded-full border-2 border-primary" />
        <div className="wh-pulse-ring-2 absolute w-24 h-24 rounded-full border border-primary" />

        {/* Logo — the artwork is drawn for white paper, so it keeps its own
            white plate in every theme. */}
        <div className="relative z-10 rounded-lg bg-white p-2 border border-subtle shadow-sm">
          <img
            src="/img/logo.png"
            alt="Whitehouse Education Zone"
            className="w-10 h-10 object-contain"
          />
        </div>
      </div>

      {/* Brand text */}
      <p className="mt-6 text-xs font-bold tracking-[0.25em] uppercase select-none text-fg-secondary">
        Whitehouse Education Zone
      </p>

      {/* Bouncing dots */}
      <div className="flex items-center gap-1.5 mt-4">
        <span className="wh-dot1 w-1.5 h-1.5 rounded-full bg-primary inline-block" />
        <span className="wh-dot2 w-1.5 h-1.5 rounded-full bg-primary inline-block" />
        <span className="wh-dot3 w-1.5 h-1.5 rounded-full bg-primary inline-block" />
      </div>
    </div>
  </>
);

export default Loader;
